import { Link } from "react-router-dom";
import EmptyState from "../../components/common/EmptyState";
import { FiLock } from "react-icons/fi";

export default function UnauthorizedPage() {
  return (
    <div className="page">
      <EmptyState icon={FiLock} title="You don't have access to this page" text="Your role doesn't include this screen. Ask HR or an Admin if you need access." action={<Link to="/dashboard" className="btn btn-primary">Go to dashboard</Link>} />
    </div>
  );
}
